<template>
  <div class="overflow-y-scroll">
    <!--    <h3>Consultant</h3>-->
    <div class="map-tech-info flex items-center justify-center">
      <div class="flex-1">
        <h3 v-if="anonymous">Anonymous</h3>
        <h3 v-else>{{(name ? name : email) | getNameByEmail}}</h3>
        <div>
          <span
            class="status-pill"
            :class="{'red' : isActive != 'true', 'green' : isActive == 'true'}"
          ></span>
          <span>{{isActive == 'true' ? 'Active' : 'Inactive'}}</span>
        </div>
        <p>{{techLevel}}</p>
      </div>
      <div class="map-tech-info-avatar" v-if="!anonymous">
        <div class="map-tech-info-avatar-container">
          <span v-if="!photo">{{(name ? name : email) | getFirstLetter}}</span>
          <img v-else :src="photo" alt />
        </div>
      </div>
    </div>
    <section class="map-info">
      <div class="form-inline" v-if="!anonymous">
        <label>Address:</label>
        <div>{{address ? address : 'none'}}</div>
      </div>
      <div class="form-inline">
        <label>Metro:</label>
        <div>{{metro ? metro : 'none'}}</div>
      </div>
      <div class="form-inline">
        <label>Tools:</label>
        <div v-if="!tools || tools.length == 0">none</div>
        <ul v-if="tools" class="tech-skill-content">
          <li v-for="(tool, index) in tools" :key="index">{{tool}}</li>
        </ul>
      </div>
      <div class="form-inline">
        <label>Bio:</label>
        <div>{{bio ? bio : 'none'}}</div>
      </div>
      <div class="form-inline">
        <label>Resume:</label>
        <a href="javascript:void(0)" @click="toResume">link</a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: [
    "name",
    "isActive",
    "address",
    "metro",
    "bio",
    "photo",
    "id",
    "anonymous",
    "techLevel",
    "tools"
  ],
  methods: {
    toResume: function() {
      const href = this.$router.resolve({
        name: "resume",
        params: { id: this.id, type: this.anonymous ? "anon" : "allinfo" }
      });
      window.open(href.href, "_blank");
    }
  }
};
</script>